<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Fake Markierung Einstellungen</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-12">
            <toggle-switch
              label="Fake Markierung erlauben"
              type="success"
              v-model="data.allow_mark"
            ></toggle-switch>
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      this.data.allow_mark = Boolean(
        this.$store.getters["setting/key"]("allow_mark")
      );
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        allow_mark: false
      }
    };
  }
};
</script>
